import { useState, useRef, useEffect } from "react";
function useLocalStorageProperly(key, defaultValue) {
  const resolveDefault = () => typeof defaultValue === "function" ? defaultValue() : defaultValue;
  const readValue = () => {
    if (typeof window === "undefined") {
      return resolveDefault();
    }
    try {
      const raw = window.localStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : resolveDefault();
    } catch (e) {
      console.warn(`Error parsing localStorage key "${key}":`, e);
      return resolveDefault();
    }
  };
  const [storedValue, setStoredValue] = useState(readValue);
  const isFirstRun = useRef(true);
  useEffect(() => {
    setStoredValue(readValue());
  }, [key]);
  useEffect(() => {
    if (typeof window === "undefined")
      return;
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    try {
      if (storedValue !== void 0) {
        window.localStorage.setItem(key, JSON.stringify(storedValue));
      } else {
        window.localStorage.removeItem(key);
      }
    } catch (err) {
      console.warn(`Error setting localStorage key "${key}":`, err);
    }
  }, [key, storedValue]);
  useEffect(() => {
    if (typeof window === "undefined")
      return;
    const handleStorage = (e) => {
      if (e.key !== key || e.storageArea !== window.localStorage)
        return;
      try {
        setStoredValue(e.newValue ? JSON.parse(e.newValue) : void 0);
      } catch (err) {
        console.warn(`Error handling storage event for key "${key}":`, err);
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [key]);
  return [storedValue, setStoredValue];
}
export {
  useLocalStorageProperly
};
